import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { formatCurrency } from '../utils/formatMoeda';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PcaSummary = ({ data }) => {

    // Mapeamento completo de categorias, cores e dados
    const allCategories = [
        { key: 'alienacaoPermissao', label: 'Alienação/Concessão/Permissão', color: '220, 0, 100' },
        { key: 'locacaoImoveis', label: 'Locação de Imóveis', color: '255, 99, 132' },
        { key: 'materiais', label: 'Materiais', color: '54, 162, 235' },
        { key: 'obras', label: 'Obras', color: '65, 88, 8' },
        { key: 'obrasServicos', label: 'Obras e Serv. Eng.', color: '23, 99, 132' },
        { key: 'servicos', label: 'Serviços', color: '0, 102, 0' },
        { key: 'servicosEngenharia', label: 'Serv. de Engenharia', color: '255, 159, 64' },
        { key: 'tic', label: 'Soluções de TIC', color: '153, 102, 255' },
    ];

    // **MELHORIA: Filtrar categorias com valor maior que zero para um gráfico mais limpo**
    const activeCategories = allCategories.filter(cat => data[cat.key] > 0);

    // Se não houver nenhuma categoria ativa, cria uma categoria "placeholder"
    const displayCategories = activeCategories.length > 0 ? activeCategories : [{ label: 'Nenhum dado', data: [1], color: '220, 220, 220' }];

    const chartData = {
        labels: displayCategories.map(cat => cat.label),
        datasets: [
            {
                label: 'Valor Total',
                data: displayCategories.map(cat => data[cat.key] || 1), // Usa 1 para o placeholder
                backgroundColor: displayCategories.map(cat => `rgba(${cat.color}, 0.7)`),
                borderColor: displayCategories.map(cat => `rgba(${cat.color}, 1)`),
                borderWidth: 1,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                // **MELHORIA: Legenda à direita para economizar espaço vertical**
                position: 'right',
                labels: {
                    boxWidth: 20, // Caixas de cor menores
                    padding: 15,
                }
            },
            title: {
                display: true,
                text: 'Distribuição de Valores por Tipo',
                font: { size: 16 }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed !== null) {
                            // Formata o valor como moeda no tooltip
                            label += formatCurrency(context.parsed);
                        }
                        return label;
                    }
                }
            }
        },
    };

    const CardItem = ({ category }) => (
        <div className="col-lg-4 col-md-6 mb-2">
            <div className="card text-center h-100 shadow-sm">
                <div className="card-header text-white small py-0" style={{ backgroundColor: `rgba(${category.color}, 1)`, fontSize: '0.8rem' }}>
                    {category.label}
                </div>
                <div className="card-body d-flex align-items-center justify-content-center p-1">
                    <h6 className="card-title mb-0 small" style={{ fontSize: '0.85rem' }}>{formatCurrency(data[category.key] || 0)}</h6>
                </div>
            </div>
        </div>
    );

    return (
        <div className="row align-items-center small" style={{ margin: 0, height: '100%' }}>
            
            {/* Coluna do Gráfico */}
            <div className="col-lg-5 col-md-12 mb-3 mb-lg-0">
                <div style={{ position: 'relative', height: '230px' }}>
                    <Doughnut data={chartData} options={chartOptions} />
                </div>
            </div>

            {/* Coluna dos Cards de Totais */}
            <div className="col-lg-7 col-md-12">
                <div className="row">
                    {/* **MELHORIA: Mapeia as categorias para criar os cards dinamicamente** */}
                    {allCategories.map(cat => (
                        <CardItem key={cat.key} category={cat} />
                    ))}
                </div>
                
                {/* Total Geral */}
                <div className="card text-center mt-2 border-dark">
                    <div className="card-header bg-dark text-white py-1" style={{ fontSize: '0.9rem' }}>
                        <strong>VALOR TOTAL DO PCA</strong>
                    </div>
                    <div className="card-body p-2">
                        <h6 className="card-title text-dark mb-0" style={{ fontSize: '1rem' }}>
                            <strong>{formatCurrency(data.totalGeral || 0)}</strong>
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PcaSummary;